import React from 'react';
import './categories.scss';
import CategoryCard from './CategoryCard';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Categories = props => {
  const {
    title = 'Search By Category',
    info,
    moreInfo = 'KNOW MORE',
    moreInfoActionUrl,
    categories,
  } = props;
  return (
    <div className="category-component">
      <div className="category-component--title vxl-section-title">{title}</div>
      {info && (
        <div className="category-component--more-info">
          <div className="category-component--more-info--info">{info}</div>
          <Link to={moreInfoActionUrl} className="button action-link more">
            {moreInfo}
          </Link>
        </div>
      )}
      <div className=""></div>
      <div className="category-component--list">
        {categories.map(cat => (
          <CategoryCard category={cat} key={cat.categoryId} />
        ))}
      </div>
    </div>
  );
};

Categories.propTypes = {
  title: PropTypes.string,
  categories: PropTypes.array.isRequired,
  info: PropTypes.string,
  moreInfo: PropTypes.string,
  moreInfoActionUrl: PropTypes.string,
};

export default Categories;
